import { Component, computed, inject, input, output } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { InstructionPopupItem } from '../../models/popup.model';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { OverlayCardItemComponent } from '../overlay-card-item/overlay-card-item';
import { NavButtonComponent } from '../nav-button/nav-button';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';

@Component({
  selector: 'app-instruction-popup',
  templateUrl: './instruction-popup.html',
  styleUrls: ['./instruction-popup.scss'],
  imports: [NzModalModule, OverlayCardItemComponent, NavButtonComponent],
})
export class InstructionPopupComponent {
  header = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  title = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  instructions = input<InstructionPopupItem[]>([]);
  connectionErrorPopup = input<boolean>(false);
  connectionFullPopup = input<boolean>(false);

  closeEvent = output<void>();
  backButtonClick = output<number>(); // preserving original type

  readonly i18n = inject(I18nService);

  showColorImplementationBanner = computed<boolean>(() => {
    // Keep the original logic: banner shown when header text matches exactly
    return this.header().trim() === 'How to choose the right color';
  });

  hasAnyConnectionPopup = computed<boolean>(() => {
    return this.connectionErrorPopup() || this.connectionFullPopup();
  });

  onClose(): void {
    this.closeEvent.emit();
  }

  connectToOtherGtway(): void {
    this.backButtonClick.emit(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  }
}
